import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ShareIosOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M8 7.00024H5.99968C4.34516 7.00024 3 8.34541 3 9.99993L3.00001 19.8163C3.00001 21.4709 4.34517 22.816 5.99969 22.816H17.8161C18.6434 22.816 19.3926 22.4797 19.936 21.9363C20.4795 21.3928 20.8158 20.6436 20.8158 19.8163V9.99993C20.8158 8.34541 19.4706 7.00024 17.8161 7.00024H16V9.00003H17.8161C18.3671 9.00003 18.816 9.44887 18.816 9.99992V19.8163C18.816 20.3688 18.3685 20.8162 17.8161 20.8162H5.99968C5.44863 20.8162 4.99979 20.3674 4.99979 19.8163V9.99992C4.99979 9.72371 5.11235 9.47443 5.29327 9.2935C5.47419 9.11258 5.72347 9.00003 5.99968 9.00003H8V7.00024Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M11 5L11 13H13L13 5H16L12 1L8 5L11 5Z",
    fill: "currentColor"
  }));
}